import { useQueryClient } from '@tanstack/vue-query'
import * as Sentry from '@sentry/vue'
import { tokenKey, roleKey } from '~/constants/auth'

const useSuccessfulLogout = () => {
  const authStore = useAuthStore()
  const queryClient = useQueryClient()
  const token = useStatefulCookie(tokenKey)
  const role = useStatefulCookie(roleKey)
  const { cleanPopup } = useUIStore()
  const localePath = useLocalePath()
  const logout = async (redirectPath?: string) => {
    cleanPopup()
    queryClient.clear()

    token.value = undefined
    role.value = undefined

    Sentry.setUser(null)

    document.dispatchEvent(
      new CustomEvent('auth:logout', {
        detail: {
          leadId: authStore.getUser?.leadId,
        },
      })
    )

    await nextTick()

    authStore.logout()
    return navigateTo(redirectPath ? localePath(redirectPath) : localePath('/login'))
  }

  return {
    logout,
  }
}

export default useSuccessfulLogout
